import TestSection from 'src/entities/AptitudeTestSection';

export default class AptitudeTest {
  id: number;
  name: string;
  sections: Array<TestSection>;

  constructor(entity: AptitudeTest) {
    this.id = entity.id;
    this.name = entity.name;
    this.sections = entity.sections ?
      entity.sections.map(section => new TestSection(section)) : [];
  }
}



// WEBPACK FOOTER //
// ./src/entities/AptitudeTest.tsx